<template>
  <div class="tab-content">
    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

      <!-- budget -->
      <el-tab-pane :disabled="!projectPermission.viewATBudget" v-if="selectedRow.type === 'project'" :label="$t('project_tab_at_budget')" name="budget">
        <!-- Current Service Under Development -->
        <!-- (Budget project) -->
        <estimateTab
          v-model="activeEstimateTab"
          :isProject="isProject"
          :selectedRow="selectedRow"
          :projectPermission="projectPermission"/>
      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskATBudget" v-else :label="$t('project_tab_at_budget')" name="budget">
        <!-- Current Service Under Development -->
        <!-- (Budget) -->
        <estimateTab
          v-model="activeEstimateTab"
          :isProject="isProject"
          :selectedRow="selectedRow"
          :projectPermission="projectPermission"/>
      </el-tab-pane>

      <!-- cash advances -->
      <el-tab-pane :disabled="!projectPermission.viewATCashAdvances" v-if="selectedRow.type === 'project'" :label="$t('project_tab_at_cashAdvances')" name="cashAdvancesProject">
          Current Service Under Development
          <!-- (Cash Advances project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskATCashAdvances" v-else :label="$t('project_tab_at_cashAdvances')" name="cashAdvancesTask">
          Current Service Under Development
          <!-- (Cash Advances) -->
      </el-tab-pane>

      <!-- expenses -->
      <el-tab-pane :disabled="!projectPermission.viewATExpenses" v-if="selectedRow.type === 'project'" :label="$t('project_tab_at_expenses')" name="expensesProject">
          Current Service Under Development
          <!-- (Expenses project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskATExpenses" v-else :label="$t('project_tab_at_expenses')" name="expensesTask">
          Current Service Under Development
          <!-- (Expenses) -->
      </el-tab-pane>

      <!-- receive payment -->
      <!-- <el-tab-pane v-if="selectedRow.type === 'project'" label="Receive Payment" name="receivePaymentProject">
          Current Service Under Development
          (Receive Payment project)
      </el-tab-pane>
      <el-tab-pane v-else label="Receive Payment" name="receivePaymentTask">
          Current Service Under Development
          (Receive Payment)
      </el-tab-pane> -->

      <!-- pay vendors -->
      <el-tab-pane :disabled="!projectPermission.viewATPayVendors" v-if="selectedRow.type === 'project'" :label="$t('project_tab_at_payVendors')" name="payVendorsProject">
          Current Service Under Development
          <!-- (Pay Vendors project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskATPayVendors" v-else :label="$t('project_tab_at_payVendors')" name="payVendorsTask">
          Current Service Under Development
          <!-- (Pay Vendors) -->
      </el-tab-pane>

    </el-tabs>

    <!-- bookmark -->
<!--    <div class="book-mark-block pointer" v-if="bookmarkList">-->
<!--      <div v-if="selectedRow.type === 'project'">-->
<!--        <div v-if="bookmarkListProject.accountTHINK" @click="changeBookMarkProject(bookmarkListProject.accountTHINK, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMarkProject(bookmarkListProject.accountTHINK, $route.query.companyId, selectedRow.projectId)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->

<!--      <div v-else>-->
<!--        <div v-if="bookmarkList.accountTHINK" @click="changeBookMark(bookmarkList.accountTHINK, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_act.svg"></div>-->
<!--        <div v-else @click="changeBookMark(bookmarkList.accountTHINK, $route.query.companyId, selectedRow.projectId, selectedRow.id)"><img src="@/assets/img/bookmark/bm_inact.svg"></div>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'

  // estimate
  import estimateTab from '@/components/Projects/accountTHINK/estimate/estimateTab.vue'

  export default {
    components: {
      estimateTab,
    },
    props: [
      'isProject',
      'selectedRow',
      'value',
      'bookmarkList',
      'bookmarkListProject',
      'projectPermission'
    ],
    data() {
      return {
        activeEstimateTab: '',
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
      }
    },
    methods: {
      handleClick(tab, event, projectTaskId) {
        // cash advances
        if(tab.label === "Cash Advances" && tab.name == "cashAdvancesProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Cash Advances" && tab.name == "cashAdvancesTask" && !this.isProject){
          // dispatch
        }

        // expenses
        if(tab.label === "Expenses" && tab.name == "expensesProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Expenses" && tab.name == "expensesTask" && !this.isProject){
          // dispatch
        }

        // receive payment
        if(tab.label === "Receive Payment" && tab.name == "receivePaymentProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Receive Payment" && tab.name == "receivePaymentTask" && !this.isProject){
          // dispatch
        }

        // pay vendors
        if(tab.label === "Pay Vendors" && tab.name == "payVendorsProject" && this.isProject){
          // dispatch
        }
        if(tab.label === "Pay Vendors" && tab.name == "payVendorsTask" && !this.isProject){
          // dispatch
        }

        // purchase
        if(tab.label === "Purchase" && tab.name == "purchaseProject" && this.isProject){
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
          loader.hide()
          // this.$refs.purchaseProjectTable.handleClick(tab, event, projectTaskId)
        }
        if(tab.label === "Purchase" && tab.name == "purchaseTask" && !this.isProject){
          // dispatch
          let loader = this.$loading.show();
          this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
          loader.hide()
          // this.$refs.purchaseTaskTable.handleClick(tab, event, projectTaskId)
        }
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      changeBookMark(state, companyid, projectId, taskId){
        let data = this.bookmarkList
        data.accountTHINK = !this.bookmarkList.accountTHINK
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
          .then(response => {
            if (this.bookmarkList.accountTHINK) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
      changeBookMarkProject(state, companyId, projectId, taskId){
        let data = this.bookmarkListProject
        data.accountTHINK = !this.bookmarkListProject.accountTHINK
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/setProject?companyId=${companyId}&projectId=${projectId}`, data)
          .then(response => {
            if (this.bookmarkListProject.accountTHINK) {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
            } else {
              this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
            }
          })
          .catch(error => {
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
// [ Modal ] end
.tab-content{
  position:relative;
  .book-mark-block{
    position:absolute;
    top:0;
    right:0;
    .el-checkbox__input{
      display:none;
    }
    .el-checkbox {
      border: none;
    }
    .el-checkbox__label{
      font-size:20px !important;
      color: #409EFF;
    }
  }
}
</style>
